import moment from "moment";
import momentTimezone from "moment-timezone";
import Booking from "src/utils/Booking";
import Constant from "src/utils/Constant";
import Helper from "src/utils/Helper";

export const DATE_AND_TIME_FORMAT = "YYYY/MM/DD";

export const EMPTY_TIME_RECORDS = {
  listofOverFlowDates: [],
  listofUnderFlowDates: [],
  listofOverflow: {},
  listofUnderflow: {},
  listOfAvailableDates: {},
};

export function createTimeMaps() {
  return {
    listofOverFlowDates: [],
    listofUnderFlowDates: [],
    listofOverflow: {},
    listofUnderflow: {},
    listOfAvailableDates: {},
  };
}

export function snapshotTimeMaps(timeMaps) {
  return {
    listofOverFlowDates: timeMaps.listofOverFlowDates,
    listofUnderFlowDates: timeMaps.listofUnderFlowDates,
    listofOverflow: timeMaps.listofOverflow,
    listofUnderflow: timeMaps.listofUnderflow,
    listOfAvailableDates: timeMaps.listOfAvailableDates,
  };
}

export function resetTimeMaps(timeMaps) {
  timeMaps.listofOverFlowDates = [];
  timeMaps.listofUnderFlowDates = [];
  timeMaps.listofOverflow = {};
  timeMaps.listofUnderflow = {};
  timeMaps.listOfAvailableDates = {};
  return timeMaps;
}

export function getClientToday(selectedTimezone) {
  return momentTimezone(new Date(), Helper.zeroTimezone).tz(selectedTimezone);
}

export function toPickerBoundDate(value) {
  return new Date(
    moment(value, DATE_AND_TIME_FORMAT).format(DATE_AND_TIME_FORMAT)
  );
}

export function getCalendarMinDate(selectedTimezone) {
  return toPickerBoundDate(getClientToday(selectedTimezone));
}

export function getCalendarMaxDate(calendarMaxDate) {
  return toPickerBoundDate(calendarMaxDate);
}

export function getPickerValue(selectedDate) {
  return selectedDate ? moment(selectedDate, DATE_AND_TIME_FORMAT) : null;
}

export function resolveOfferRequestIds({
  offerId,
  userId,
  organizationId,
  selectedOffer,
} = {}) {
  return {
    offerId: offerId ?? selectedOffer?.id,
    userId: userId ?? selectedOffer?.user_id,
    organizationId: organizationId ?? selectedOffer?.organization_id,
  };
}

/**
 * Greys out calendar days that have no package sessions, overflow, or underflow.
 * generateSessionTime still mutates timeMaps during a single calendar paint.
 */
export function shouldDisableCalendarDate(date, {
  selectedOffer,
  coachDetails,
  selectedTimezone,
  timeMaps,
  isUseTimeRecord,
  timeRecords,
}) {
  const appointmentInterval =
    selectedOffer?.custom_options?.interval ?? Constant.interval;

  const isWholeDayBlockedByCoach = Booking._dateandtime.isWholeDayBlockedByCoach(
    selectedOffer,
    date,
    coachDetails?.timezone_utc,
    selectedTimezone
  );

  if (isWholeDayBlockedByCoach) {
    return true;
  }

  const packageAvailability = Booking._dateandtime.getPackageAvailability(
    date,
    selectedOffer
  );

  Booking._dateandtime.generateSessionTime(
    packageAvailability,
    selectedOffer?.duration,
    date,
    selectedTimezone,
    coachDetails,
    appointmentInterval,
    timeMaps.listofOverFlowDates,
    timeMaps.listofOverflow,
    timeMaps.listofUnderFlowDates,
    timeMaps.listofUnderflow,
    timeMaps.listOfAvailableDates
  );

  const today = moment(date).format(DATE_AND_TIME_FORMAT);
  const day = moment(date, "dddd").format("dddd");
  const daysEnabled = Booking._dateandtime.getDayEnableInPackage(
    date,
    selectedOffer
  );
  const dayIsEnable = Booking._dateandtime.isDayEnable(daysEnabled, day);

  const records = timeRecords ?? EMPTY_TIME_RECORDS;

  const hasOverflow = isUseTimeRecord
    ? Boolean(records.listofOverFlowDates?.includes(today.toString()))
    : timeMaps.listofOverFlowDates.includes(today.toString());
  const hasUnderFlow = isUseTimeRecord
    ? Boolean(records.listofUnderFlowDates?.includes(today.toString()))
    : timeMaps.listofUnderFlowDates.includes(today.toString());
  const hasSessions = isUseTimeRecord
    ? records.listOfAvailableDates[today]
    : timeMaps.listOfAvailableDates[today];

  if (hasOverflow) return false;
  if (hasUnderFlow) return false;
  if (!hasSessions && !hasOverflow && !hasUnderFlow) return true;
  if (!dayIsEnable) return false;
  return true;
}
